if (document.querySelector('.exchange-block')) {

  let form = document.querySelector('.exchange-block'),
      inputValue = document.querySelector('.exchange-block__input-val_input'),
      inputResult = document.querySelector('.exchange-block__input-val_result'),
      spanValue = document.querySelector('.exchange-info__text span:first-child'),
      spanResult = document.querySelector('.exchange-info__text span:last-child');

  let html = '<div class="input-buffer" style="position: absolute;top: -1000px;left: -1000px;visibility: hidden;white-space: nowrap;font-size: 20px;font-weight: bold;font-family: \'Gotham Pro\', sans-serif;"></div>';
  document.body.insertAdjacentHTML('beforeEnd', html);
  let buffer = document.querySelector('.input-buffer');
  function inputWidth(input) {
    buffer.innerHTML = input.value + ' ';
    input.style.width = '100%';
    input.style.maxWidth = buffer.clientWidth + 'px';
  }

  form.querySelectorAll('.currency-select__button, .currency-select__button *').forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      e.target.closest('.currency-select').classList.toggle('active');
    })
  });

  function currencySelect (button, noRecalcExchange) {
    let selector = button.closest('.currency-select'),
        currencyCode = button.getAttribute('data-currencycode'),
        currencyImg = button.querySelector('img').getAttribute('src'),
        currencyRate = button.getAttribute('data-rate'),
        currencyVal = button.getAttribute('data-val');

    if (selector.querySelector('.currency-select__currency.d-none')) {
      selector.querySelector('.currency-select__currency.d-none').classList.remove('d-none');
    }

    selector.querySelector('.exchange-block__input input').setAttribute('data-currencycode', currencyCode);
    selector.querySelector('.currency-select__button').innerHTML = currencyCode;
    selector.querySelector('.exchange-block__input input').setAttribute('data-rate', currencyRate);
    selector.querySelector('.exchange-block__input input').setAttribute('data-val', currencyVal);
    selector.querySelector('.exchange-block__input img').setAttribute('src', currencyImg);

    selector.closest('.exchange-block__column').querySelector('.on-the-account span').innerHTML = currencyVal + ' ' + currencyCode;

    button.classList.add('d-none');
    if (selector.classList.contains('active')) {
      selector.classList.remove('active');
    }
    if (noRecalcExchange) {
      return;
    }
    recalcExchange();
  }

  form.querySelectorAll('.currency-select__currency.d-none').forEach((el) => {
    currencySelect(el, true);
  });

  form.querySelectorAll('.currency-select__currency').forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();
      let button = e.target.closest('.currency-select__currency') ? e.target.closest('.currency-select__currency') : e.target;
      currencySelect(button);
    })
  });

  let roundUp = {
    'rub': 2,
    'usd': 2,
    'eur': 2,
    'btc': 6,
    'dash': 5
  };

  function recalcExchange() {
    let inputValueRoundUp = roundUp[inputValue.getAttribute('data-currencycode')] || 2;
    let inputResultRoundUp = roundUp[inputResult.getAttribute('data-currencycode')] || 2;
    inputResult.value = (inputValue.value / inputValue.getAttribute('data-rate') * inputResult.getAttribute('data-rate')).toFixed(inputResultRoundUp);
    spanValue.innerHTML = Number(inputValue.value).toFixed(inputValueRoundUp) + ' ' + inputValue.getAttribute('data-currencycode');
    spanResult.innerHTML = Number(inputResult.value).toFixed(inputResultRoundUp) + ' ' + inputResult.getAttribute('data-currencycode');

    if (inputValue.value > parseFloat(inputValue.getAttribute('data-val'))) {
      form.querySelector('.exchange-info .button').setAttribute('disabled', 'disabled');
    } else {
      form.querySelector('.exchange-info .button').removeAttribute('disabled');
    }

    inputWidth(inputResult);
  }

  function toggle() {
    let currencyCode1 = form.querySelector('.exchange-block__wr .exchange-block__column:first-child .currency-select__currency.d-none').getAttribute('data-currencycode'),
      currencyCode2 = form.querySelector('.exchange-block__wr .exchange-block__column:last-child .currency-select__currency.d-none').getAttribute('data-currencycode');
    currencySelect(form.querySelector('.exchange-block__wr .exchange-block__column:last-child .currency-select__currency[data-currencycode=' + currencyCode1 + ']'), true);
    currencySelect(form.querySelector('.exchange-block__wr .exchange-block__column:first-child .currency-select__currency[data-currencycode=' + currencyCode2 + ']'));
  }

  function changeCard (card) {
    form.querySelector('.card-button.active').classList.remove('active');
    card.classList.add('active');
    let info = JSON.parse(card.getAttribute('data-balance'));
    form.querySelectorAll('.currency-select__currency').forEach(button => {
      button.setAttribute('data-val', info[(button.getAttribute('data-currencycode')).toUpperCase()]);
      button.querySelector('span').innerHTML = '<b>' + (button.getAttribute('data-currencycode')).toUpperCase() + '</b> (' +  button.getAttribute('data-val') + ')';
      if (button.classList.contains('d-none')) {
        currencySelect(button, true)
      };
    });
    recalcExchange();
  }

  form.querySelectorAll('.card-button').forEach(card => {
    card.addEventListener('click', evt => {
      evt.preventDefault();
      changeCard(card);
    })
  })

  form.querySelectorAll('.exchange-block__icon').forEach(item => {
    item.addEventListener('click', () => {
      toggle();
    });
  });

  inputValue.addEventListener('keyup', () => {
    recalcExchange();
    inputWidth(inputValue);
  });

};
